'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _breakPointMediator = require('../breakpoint/breakPointMediator');

var _breakPointMediator2 = _interopRequireDefault(_breakPointMediator);

var _store = require('../../store/store');

var _store2 = _interopRequireDefault(_store);

var _adsActions = require('../../store/actions/ads-actions');

var Actions = _interopRequireWildcard(_adsActions);

var _helpers = require('../helpers');

var _dfpLoader = require('./vendors/dfpLoader');

var _dfpLoader2 = _interopRequireDefault(_dfpLoader);

var _indexLoader = require('./vendors/indexLoader');

var _indexLoader2 = _interopRequireDefault(_indexLoader);

var _kruxLoader = require('./vendors/kruxLoader');

var _kruxLoader2 = _interopRequireDefault(_kruxLoader);

var _amzLoader = require('./vendors/amzLoader');

var _amzLoader2 = _interopRequireDefault(_amzLoader);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Dfp Ads utility to handle all api interactions
 * Dependencies:
 * Any ad implementation requires:
 *  BreakPointIndicator (on top of the page) to detect device
 *  DFPAdsProvider (as a wrapper) to sync the initial above the fold ad calls
 *  BS API Data to set ad values
 *  Redux as single source of truth
 */
var dfpManager = {
  /**
   * Function that initializes the global window object with ad libraries
   * @param {array} result Carries results from the async calls to load the different ad libraries
   */
  initGlobals: function initGlobals(result) {
    window.googletag = window.googletag || result[0];
    window.Krux = window.Krux || result[1];
  },


  /**
   * Returns an array of vendor library async fetches
   * @returns {array} fetches Array of vendor library async fetches
   */
  getVendorFetches: function getVendorFetches() {
    var fetches = [(0, _dfpLoader2.default)(), (0, _kruxLoader2.default)()];
    return fetches;
  },


  /**
   * Loading async vendor libraries
   * @param {array} vendorFetches Array of vendor library async fetches
   */
  load: function load() {
    var _this = this;

    var vendorFetches = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getVendorFetches();

    _promise2.default.all(vendorFetches).then(function (result) {
      _this.initGlobals(result);
    }).catch(function () {
      // Monitor.captureMessage(reason);
    });
  },


  /**
   * Slot After rendering callback
   * @param {Object} event after rendering
   * @returns {string} className Ad container className
   */
  slotRenderEndedCallback: function slotRenderEndedCallback(event) {
    var adId = event.slot.getSlotId().getDomId();
    var adDiv = document.getElementById(adId);
    var ad = this.getAdById(adId);

    if (event.isEmpty) {
      adDiv.parentElement.className += ' uvs-ad-wrapper-empty';
    }

    adDiv.style.minWidth = 'auto';
    adDiv.style.minHeight = 'auto';

    if (ad && ad.callback) {
      ad.callback(event);
    }
    return adDiv;
  },


  /**
   * Initializing gpt on callback
   */
  gptInit: function gptInit() {
    var _this2 = this;

    var _window = window,
        googletag = _window.googletag;
    // krux tags

    var _window2 = window,
        Krux = _window2.Krux;

    if (typeof Krux !== 'undefined') {
      if (typeof Krux.user !== 'undefined') {
        googletag.pubads().setTargeting('kuid', Krux.user);
      }
      if (typeof Krux.segments !== 'undefined') {
        googletag.pubads().setTargeting('ksg', Krux.segments);
      }
    }
    googletag.pubads().enableSingleRequest();
    googletag.pubads().disableInitialLoad();
    googletag.pubads().enableAsyncRendering();
    googletag.pubads().setCentering(true);
    googletag.pubads().addEventListener('slotRenderEnded', function (e) {
      return _this2.slotRenderEndedCallback(e);
    });
    googletag.enableServices();
  },


  /**
   * Helper to create sequence (D-F728-1)
   * @param {string} device from client
   * @param {array} sizes array of arrays
   * @returns {array} ads that are refreshable
   */
  getSequence: function getSequence(device, sizes) {
    var state = _store2.default.getState();
    var sec = '';
    if (Array.isArray(sizes) && sizes.length) {
      // M, T or D depending on device
      sec += device.substring(0, 1).toUpperCase() + '-';
      if (this.isFlex(sizes)) {
        sec += 'F';
      }
      sec += this.getAdTypeBySize(sizes);
      sec += '-' + state.dfpAds.sequenceOrder;
      _store2.default.dispatch(Actions.increaseSequence());
    }
    return sec;
  },


  /**
   * Helper to get breakpoint attribute
   * @returns {string}
   */
  getBkpAttr: function getBkpAttr() {
    /*
     - Breakpoints >/=1440 should pass a key-value of bkpt=1440
     - Breakpoints <1440 and >/=1024 should pass a key-value of bkpt=1024
     - Breakpoints <1024 and >/=768 should pass a key-value of bkpt=768
     - Breakpoints <768 should pass a key-value of bkpt=320
      Base on:
     $grid-breakpoints: (
     xxs: 0,
     xs: 480px,
     sm: 768px,
     md: 1024px,
     lg: 1280px,
     xl: 1440px
     );
     */
    var bkpWidth = _breakPointMediator2.default.getWidth();
    var bkpt = 320;
    switch (true) {
      case bkpWidth >= 1440:
        bkpt = 1440;
        break;
      case bkpWidth < 1440 && bkpWidth >= 1024:
        bkpt = 1024;
        break;
      case bkpWidth < 1024 && bkpWidth >= 768:
        bkpt = 768;
        break;
      case bkpWidth < 768:
      default:
        bkpt = 320;
        break;
    }
    return bkpt;
  },

  /**
   * Gets ad name based on device, config and
   * environment
   * Example:
   * /7009/d.tv/homepage
   * /networkCode/adValuePrefix.channel/tag
   * @param {Object} data form the api
   * @returns {string} adName value
   */
  getAdName: function getAdName() {
    var state = _store2.default.getState();
    var env = 'production';
    if ((0, _helpers.hasKey)(state, 'dfpAds.env')) {
      /* eslint prefer-destructuring: ["error", {AssignmentExpression: {array: true}}] */
      env = state.dfpAds.env;
    }
    // The advertisement env can be overridden using the query string params "mode" or "debug"
    if ((0, _helpers.hasKey)(state, 'dfpAds.requestParams')) {
      if (state.dfpAds.requestParams.mode === 'test' || state.dfpAds.requestParams.debug === 'true') {
        env = 'test';
      } else if (state.dfpAds.requestParams.mode === 'prod') {
        env = 'production';
      }
    }

    var device = _breakPointMediator2.default.getDevice();
    var adName = '';
    if ((0, _helpers.hasKey)(state, 'dfpAds.settings.dfp.adValue') && // /tv/homepage
    (0, _helpers.exists)(state.dfpAds.settings.dfp[env]) && // test
    typeof state.dfpAds.settings.dfp[env].networkCode !== 'undefined' // 6881
    ) {
        // /6881
        adName = '/' + state.dfpAds.settings.dfp[env].networkCode;
        if (device !== '' && device === 'tablet') {
          device = 'desktop';
        }
        var prefix = device + 'AdValuePrefix';
        if (typeof state.dfpAds.settings.dfp[env][prefix] !== 'undefined') {
          // /6881/d.
          adName += '/' + state.dfpAds.settings.dfp[env][prefix];
        }
        // /7009/d.tv/homepage
        adName += state.dfpAds.settings.dfp.adValue.substring(1);
      }
    return adName;
  },


  /*
   * Get ready to display ads
   * @param {array} ads array
   * @returns {array} ads ready to display
   */
  getReadyAds: function getReadyAds(ads) {
    return ads.filter(function (ad) {
      return !ad.displayed;
    });
  },


  /*
   * Get standard ads using sequenceable flag
   * @param {array} ads array
   * @returns {array} ads ready to display
   */
  getStandardAds: function getStandardAds(ads) {
    return ads.filter(function (ad) {
      return ad.sequenceable && !ad.displayed;
    });
  },


  /*
   * Get Ad by id
   * @param {string} id to find
   * @param {array} ads array
   * @returns {object} ad that match id
   */
  getAdById: function getAdById(id) {
    if ((0, _helpers.hasKey)(_store2.default.getState(), 'dfpAds.ads')) {
      var ads = _store2.default.getState().dfpAds.ads;
      var adArray = ads.filter(function (ad) {
        return ad.slotID === id;
      });
      if (adArray.length) {
        return adArray[0];
      }
    }
    return null;
  },


  /**
   * Get refreshable ads
   * @param {array} ads array
   * @returns {array} ads that are refreshable
   */
  getRefreshableAds: function getRefreshableAds(ads) {
    return ads.filter(function (ad) {
      return ad.refreshable;
    });
  },


  /**
   * Helper to get ad type (728)
   * @param {array} sizes of ad
   * @returns {string}
   */
  getAdTypeBySize: function getAdTypeBySize(sizes) {
    if (Array.isArray(sizes) && sizes.length) {
      return sizes[0][0];
    }
    return '';
  },


  /**
   * Verify if ad is flex type
   * @param {array} sizes of ad
   * @returns {boolean}
   */
  isFlex: function isFlex(sizes) {
    return Array.isArray(sizes) && sizes.length && sizes.length > 1;
  },


  /**
   * Verify if the top ad is in the group
   * @param {array} ads to be displayed
   * @returns {boolean}
   */
  isTopAdIncluded: function isTopAdIncluded(ads) {
    var topAd = ads.filter(function (ad) {
      return ad.position === 'TOP';
    });
    return topAd.length > 0;
  },


  /**
   * Displaying ads
   */
  displayAds: function displayAds() {
    var _this3 = this;

    if (typeof window.googletag === 'undefined') {
      this.load();
    }
    var slots = [];
    var slot = {};
    var ads = this.getReadyAds(_store2.default.getState().dfpAds.ads);
    if (window.googletag && window.googletag.apiReady) {
      if (ads.length > 0) {
        ads.forEach(function (ad) {
          // Enabling service if not ready yet
          if (!window.googletag.pubadsReady) {
            _this3.gptInit();
          }
          slot = _this3.defineSlot(ad);
          slots.push(slot);
          _store2.default.dispatch(Actions.displayAd(ad.slotID));
          window.googletag.display(ad.slotID);
        });
        if (typeof window.apstag !== 'undefined') {
          window.apstag.setDisplayBids();
        }
        window.googletag.pubads().refresh(slots);
        (0, _indexLoader2.default)();
        (0, _amzLoader2.default)();
      }
    }
  },


  /**
   * Displaying ads
   * @param {array} ads to be populated
   * @param {boolean} amz use amazon bid
   */
  refreshAds: function refreshAds() {
    if (typeof window.googletag === 'undefined') {
      this.load();
    }
    var slots = [];
    var ads = this.getRefreshableAds(_store2.default.getState().dfpAds.ads);
    if (ads.length > 0) {
      window.googletag.cmd.push(function () {
        ads.forEach(function (ad) {
          slots.push(ad.slot);
        });
        window.googletag.pubads().refresh(slots);
      });
    }
  },


  /**
   * Separate amazon or regular ads
   * @param {array} ads not displayed yet
   */
  preFetchAds: function preFetchAds() {
    var _this4 = this;

    if (typeof window.googletag === 'undefined') {
      this.load();
    }
    window.googletag.cmd.push(function () {
      var slots = _this4.getStandardAds(_store2.default.getState().dfpAds.ads);
      if (slots.length && !_this4.isTopAdIncluded(slots) && typeof window.apstag !== 'undefined') {
        window.apstag.fetchBids({
          slots: slots,
          timeout: 2e3
        }, function () {
          return _this4.displayAds();
        });
      } else {
        _this4.displayAds();
      }
    });
  },


  /**
   * Define slots
   * @param {Object} slot settings from ad definition
   * @returns {Object}
   */
  defineSlot: function defineSlot(_ref) {
    var adName = _ref.adName,
        sizes = _ref.sizes,
        slotID = _ref.slotID,
        device = _ref.device,
        position = _ref.position,
        sequenceable = _ref.sequenceable;

    var slot = window.googletag.defineSlot(adName, sizes, slotID).addService(window.googletag.pubads());
    window.googletag.sizeMapping();
    slot.setTargeting('client', device);
    if (typeof position !== 'undefined') {
      slot.setTargeting('pos', position);
    }
    // Providing sec targeting attr
    if (sequenceable) {
      slot.setTargeting('seq', this.getSequence(device, sizes));
    }
    // Providing tag targeting attr
    var state = _store2.default.getState();
    if ((0, _helpers.hasKey)(state, 'dfpAds.settings.targeting.tag') && Array.isArray(state.dfpAds.settings.targeting.tag)) {
      slot.setTargeting('tag', state.dfpAds.settings.targeting.tag.join(','));
    }
    // Include contenttype key value pair if defined on store
    // this will be added in the provider
    if ((0, _helpers.hasKey)(state, 'dfpAds.contentType')) {
      slot.setTargeting('contenttype', state.dfpAds.contentType);
    }

    // Providing bkpt targeting attr
    slot.setTargeting('bkpt', this.getBkpAttr());
    _store2.default.dispatch(Actions.defineSlot(slotID, slot));
    return slot;
  },


  /**
   * Adding Slots from ad componets
   * Slot object is coming with this keys:
   * sizeMapping,
   * slotID,
   * position,
   * refreshable,
   * callback
   * @param {Object} slot from Ad component
   */
  registerSlot: function registerSlot(slot) {
    if (typeof window.googletag === 'undefined') {
      this.load();
    }
    // To avoid parameter reassignment
    var readySlot = slot;
    var device = _breakPointMediator2.default.getDevice();
    readySlot.device = device;
    readySlot.refreshable = readySlot.refreshable || false;
    if (typeof device !== 'undefined' && device !== '' && typeof readySlot.sizeMapping !== 'undefined' && typeof readySlot.sizeMapping[device] !== 'undefined') {
      readySlot.sizes = readySlot.sizeMapping[device];
    }
    readySlot.adName = this.getAdName();
    _store2.default.dispatch(Actions.registerSlot((0, _extends3.default)({}, readySlot, { displayed: false })));
    if ((0, _helpers.hasKey)(_store2.default.getState(), 'dfpAds.displayAboveTheFold') && _store2.default.getState().dfpAds.displayAboveTheFold) {
      this.preFetchAds();
    }
  }
};

exports.default = dfpManager;


//////////////////
// WEBPACK FOOTER
// ./~/@univision/fe-commons/dist/utils/ads/dfpManager.js
// module id = 66
// module chunks = 35783957827783 71851226274881